module.exports = __webpack_public_path__ + "public/SiteIcons/totalRooms.svg?2704c8f5";